var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',[_vm._v("Checking if the customer is risky or not...")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }